import QuestionVM from './question-vm';
export default function(mediaPlayer, koAllCues, trackingData) {
  var _self = this;
  _self._media_player = {};
  _self._media_player = mediaPlayer;
  _self._koAllCues = koAllCues;
  _self._trackingData = trackingData;
  _self._koQuestionCues = [];
  _self._$questionMarkers = [];
  _self._$nextQuestionCtrl = null;
  _self._$prevQuestionCtrl = null;
  _self._autoplay = true;
  _self._dataLoaded = false;
  _self._active = true;

  _self._cueLeftIx = -1; //index of the cue to the left (earlier) of current time
  _self._cueRightIx = -1; //index of the cue to the right (later) of current time
  _self._askingQuestion = false;
  var _asked = {}; //TODO may be superfluous

  _self.cleanup = function() {
    _self._media_player.removeEventListener('timeupdate', _self.timeUpdateHandler);
    $('.student-question__video-overlay, .student-question__panel').remove();
    _self._media_player.videoDisplay$El().find('video').removeClass('student-question__video-blur');
    _self.removeQuestionMarkers();
    _self._active = false;
  };

  _self.seekToNextQuestion = function() {
    var curTime = Math.round10(_self._media_player.currentTime(), -3);
    var nextQ = null;
    var nextQIX = -1;

    for(var i = 0; i < _self._koQuestionCues.length; i++) {
      if(Math.round10(_self._koQuestionCues[i].cue_start_time(), -3) > curTime) {
        nextQ = _self._koQuestionCues[i];
        nextQIX = i;
        break;
      }
    }

    if(nextQ) {
      _self._media_player.currentTime(nextQ.cue_start_time());
    }
    //else ignore, already past last question
    return nextQIX;
  };

  _self.seekToPreviousQuestion = function() {
    var curTime = Math.round10(_self._media_player.currentTime(), -3);
    var prevQ = null;
    var prevQIX = -1;

    for(var i = _self._koQuestionCues.length - 1; i >= 0; i--) {
      if(Math.round10(_self._koQuestionCues[i].cue_start_time(), -3) < curTime) {
        prevQ = _self._koQuestionCues[i];
        prevQIX = i;
        break;
      }
    }

    if(prevQ) {
      _self._media_player.currentTime(prevQ.cue_start_time());
    }
    //else ignore, already before first cue
    return prevQIX;
  };

  _self.insertQuestionMarkers = function() {
    var $questionMarker = $('<div class=\'kdze-question-marker\'></div>');
    _.each(_self._koQuestionCues, function(question) {
      //insert markers just before seek handle, to maintain appropriate z-ordering:
      var $qmClone = $questionMarker.clone();
      $qmClone.attr('title', question.cued.name());
      $qmClone.data('question', question);
      _self._media_player.seekBar$El().find('.vjs-play-progress').before($qmClone);
      _self._$questionMarkers.push($qmClone);

      var markerPosPercent = parseFloat(question.cue_start_time()) / Math.round10(_self._media_player.duration(), -3) * 100.0;
      $qmClone.css('left', markerPosPercent.toString() + '%');

      $qmClone.on('mousedown', function(evt) {
        evt.stopPropagation();
        _self._media_player.currentTime(question.cue_start_time());
        //what question?
        var qIX = _self._koQuestionCues.indexOf(question);
        if(qIX != -1) {
          _self._autoplay = false;
          _self.askQuestion(qIX);
        }
      });
    });
  };

  _self.initPresentation = function() {
    $('.kdze-question-marker').remove();
    _self.removeQuestionMarkers();

    _self._$nextQuestionCtrl && _self._$nextQuestionCtrl.remove();
    _self._$nextQuestionCtrl = null;
    _self._$prevQuestionCtrl && _self._$prevQuestionCtrl.remove();
    _self._$prevQuestionCtrl = null;
    _self._autoplay = true;
    _self._cueLeftIx = -1;
    _self._cueRightIx = -1;
    _self._askingQuestion = false;
    _asked = {}; //TODO may be superfluous
  };

  _self.removeQuestionMarkers = function() {
    _.each(_self._$questionMarkers, function($marker, ix) {
      $marker.remove();
    });

    _self._$questionMarkers = [];
  };

  _self.present = function() {

    var ac = _self._koAllCues();
    _.each(ac, function(koCue, ix) {
      if(koCue.type && koCue.type() === 'MediaQuestion') {
        _self._koQuestionCues.push(koCue);
      }
    });
    _self.initPresentation();

    if(_self._koQuestionCues.length === 0)
      return;

    !_self._media_player.shown() && _self._media_player.show(); //need a player to decorate

    //add custom controls to media player
    _self._$nextQuestionCtrl = $('<div class=\'kdze-next-cue kdze-control\' title=\'' + Kadenze.I18n.t('session.media.next_question') + '\'></div>');
    _self._$prevQuestionCtrl = $('<div class=\'kdze-prev-cue kdze-control\' title=\'' + Kadenze.I18n.t('session.media.previous_question') + '\'></div>');

    _self._$nextQuestionCtrl.on('click', function() {
      var qIX = _self.seekToNextQuestion();
      if(qIX != -1) {
        _self._autoplay = false;
        _self.askQuestion(qIX);
      }
    });

    _self._$prevQuestionCtrl.on('click', function() {
      var qIX = _self.seekToPreviousQuestion();
      if(qIX != -1) {
        _self._autoplay = false;
        _self.askQuestion(qIX);
      }
    });

    //make sure player is ready
    (function poll() {
      //is the media ready?
      if(_self._media_player.duration() == 0 || !_self._media_player.metaReady()) {
        setTimeout(poll, 100);
      }
      else if (_self._active) {
        _self._media_player.transportBar$El().append(_self._$nextQuestionCtrl);
        _self._media_player.transportBar$El().append(_self._$prevQuestionCtrl);

        _self.insertQuestionMarkers();

        var currentTime = _self._media_player.currentTime(); //can't assume we're starting at 0
        //if there is a question at time zero, ask it immediately
        if(currentTime == 0 && _self._koQuestionCues[0] && parseFloat(_self._koQuestionCues[0].cue_start_time()) == 0.0) {
          _self.askQuestion(0);
        }

        //set initial values
        _self._cueLeftIx = _self.findNextCueIndex(currentTime, false);
        _self._cueRightIx = _self.findNextCueIndex(currentTime, true);

        _self._media_player.addEventListener('timeupdate', _self.timeUpdateHandler);
      }
    })();
  };

  _self.findNextCueIndex = function(starting_at_time, forward) {
    var candidates = _self._koQuestionCues.filter(function(koCue) {
      if(forward)
        return starting_at_time <= parseFloat(koCue.cue_start_time());
      else
        return starting_at_time >= parseFloat(koCue.cue_start_time());
    });

      //sort
    candidates.sort(function(a, b) {
      if(parseFloat(a.cue_start_time()) < parseFloat(b.cue_start_time()))
        return forward ? -1 : 1;
      if(parseFloat(a.cue_start_time()) > parseFloat(b.cue_start_time()))
        return forward ? 1 : -1;
      return 0;
    });

    return candidates[0] ? _self._koQuestionCues.indexOf(candidates[0]) : -1;
  };

  _self.requestTimeout = function(fn, delay, args) {
    var start = new Date().getTime();
    var theArgs = args;
    (function loop() {
      //console.log('loop');
      var current = new Date().getTime(),
        delta = current - start;

      delta >= delay ? fn.call(_self, theArgs) : requestAnimationFrame(loop);
    })();
  };

  //the student 'question sequencer'
  _self.timeUpdateHandler = function() {
    var paused = _self._media_player.paused();
    var currentTime;

    if(!_self._askingQuestion && !paused) {
      currentTime = _self._media_player.currentTime();

      //out of bounds?
      var oob = false;
      if(_self._cueLeftIx === -1 && _self._cueRightIx === -1)
        oob = true; //we're in an unknown/initial state
      else if(_self._cueLeftIx != -1 && _self._cueRightIx != -1) {
        //we have cues on either side of our window
        if(!(currentTime >= parseFloat(_self._koQuestionCues[_self._cueLeftIx].cue_start_time()) && currentTime <= parseFloat(_self._koQuestionCues[_self._cueRightIx].cue_start_time())))
          oob = true;
      }
      //current cue time window only has a cue on the right
      else if(_self._cueLeftIx === -1 && currentTime > parseFloat(_self._koQuestionCues[_self._cueRightIx].cue_start_time()))
        oob = true;
      //current cue time window only has a cue on the left
      else if(_self._cueRightIx === -1 && currentTime < parseFloat(_self._koQuestionCues[_self._cueLeftIx].cue_start_time()))
        oob = true;

      //expensive operation, so do it only if we have to:
      if(oob) {
        _self._cueLeftIx = _self.findNextCueIndex(currentTime, false);
        _self._cueRightIx = _self.findNextCueIndex(currentTime, true);
      }

      //are we near a question?
      var lookAheadTime = 0.5;
      //timeupdate is coarse and variable. Need a large lookAheadTime and to look back
      //as well as forward. If we look back and a question is within lookAheadTime
      //and hasn't been asked, ask it first.

      var candidateBeforeCurrentTimeIx = -1;
      var candidateAfterCurrentTimeIx = -1;
      var questionToAskIx = -1;
      if(_self._cueLeftIx != -1 && _self._cueRightIx != -1) {
        //did we skip over one?
        //if(currentTime - parseFloat(_self._koQuestionCues[_self._cueLeftIx].cue_start_time()) <= lookAheadTime)
        //    candidateBeforeCurrentTimeIx = _self._cueLeftIx;

        //is there one coming up?
        if(parseFloat(_self._koQuestionCues[_self._cueRightIx].cue_start_time()) - currentTime <= lookAheadTime)
          candidateAfterCurrentTimeIx = _self._cueRightIx;
      }
      else if(_self._cueLeftIx === -1 && parseFloat(_self._koQuestionCues[_self._cueRightIx].cue_start_time()) - currentTime <= lookAheadTime)
        candidateAfterCurrentTimeIx = _self._cueRightIx;
      //else if(_self._cueRightIx === -1 && currentTime - parseFloat(_self._koQuestionCues[_self._cueLeftIx].cue_start_time()) <= lookAheadTime)
      //    candidateBeforeCurrentTimeIx = _self._cueLeftIx;

      //pick a candidate
      //if(candidateBeforeCurrentTimeIx != -1 && !_asked.hasOwnProperty(candidateBeforeCurrentTimeIx))
      if(candidateBeforeCurrentTimeIx != -1)
        questionToAskIx = candidateBeforeCurrentTimeIx; //biased backward
      //else if(candidateAfterCurrentTimeIx != -1 && !_asked.hasOwnProperty(candidateAfterCurrentTimeIx))
      else if(candidateAfterCurrentTimeIx != -1)
        questionToAskIx = candidateAfterCurrentTimeIx;

      //ask it
      if(questionToAskIx != -1) { // && questionToAskIx != _lastQuestionIX)
        _self._askingQuestion = true;

        var qTime = parseFloat(_self._koQuestionCues[questionToAskIx].cue_start_time());
        currentTime = _self._media_player.currentTime();
        var timeDelta = 0;

        if(currentTime < qTime) //wait only if we haven't overshot the question time
        {
          timeDelta = Math.round((qTime - currentTime) * 1000);
        }

        //do this on a timer
        if(window.requestAnimationFrame) {
          _self.requestTimeout(_self.askQuestion, timeDelta, questionToAskIx); //high resolution timing
        } else {
          setTimeout(_self.askQuestion, timeDelta, questionToAskIx); //one shot wait and ask (less accurate)
        }
      }
    }
  };

  _self.askQuestion = function(qix) {
    var questionIX = qix;
    var question = _self._koQuestionCues[questionIX];
    console.log('Asking question ' + question.cued.name());

    // Strip any script tags out of the questions content
    _.each(question.cued.definition(), function(def) {
      return $('<div/>').append($.parseHTML(def.question())).html();
    });

    //pause video, show question, etc.
    var qTime = parseFloat(question.cue_start_time());

    _self._media_player.pause();
    _self._media_player.currentTime(qTime+.01); //jump to slightly past question (adding .01 fixes an intermittent bug in safari where quiz questions re-showed)
    $('.vjs-big-play-button').hide();

    if(is.mobile()) {
      _self._media_player.exitFullscreen(); // on iOS the question won't show in fullscreen due to native control
    }

    var $displaySurface = _self._media_player.videoDisplay$El();

    //hide transport bar and text tracks
    _self._media_player.transportBar$El().hide();
    _self._media_player.textTracksDisplay$El().hide();
    //add video overlay and blur
    var $qVideoOverlay = $('<div class=\'student-question__video-overlay\'></div>');
    $displaySurface.append($qVideoOverlay);
    $displaySurface.find('video').addClass('student-question__video-blur');

    //build and show question panel
    var $qPanel = $('<div class=\'student-question__panel\'></div>');
    var $questionTemplate = $(Kadenze.I18n.tt(JST['templates/media-question-presenter'](), 'en'));

    var continue_cb = function(didSkip) {
      if(!didSkip) {
        _asked[questionIX] = true;
        //var $marker = findMarkerForQuestionIX(questionIX);
        //$marker.addClass('student-question__answered');
      }

      //show transport bar, cc, unblur, etc.
      $qVideoOverlay.remove();
      $qPanel.remove();
      $displaySurface.find('video').removeClass('student-question__video-blur');

      _self._media_player.transportBar$El().show();
      _self._media_player.textTracksDisplay$El().show();

      _self._askingQuestion = false;

      //don't autoplay if navigated to question via marker controls
      _self._media_player.play(_self._autoplay);
      _self._autoplay = true; //prefer autoplaying
    };

    var questionVM = new QuestionVM(question, _self._media_player, continue_cb, _self._trackingData);
    ko.applyBindings(questionVM, $questionTemplate[0]);
    $qPanel.append($questionTemplate);
    $displaySurface.append($qPanel);

    //put it on stage
    //$qPanel.animate({'bottom': '+=11px'}, 200).animate({'bottom': '-=2px'}, 50).animate({'bottom': '+=1px'}, 25);
  };

  _self.findMarkerForQuestionIX = function(questionIX) {
    return _.find(_self._$questionMarkers, function($marker) {
      return $marker.data('question').id() === _self._koQuestionCues[questionIX].id();
    });
  };
}

